export const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],

    [{ color: [] }, { background: [] }],

    ['link', 'image'],
  ],
};

export const formats = [
  'bold',
  'color',
  'background',
  'font',
  'italic',
  'link',
  'size',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'image',
];

export const adviceModules = {
  toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
};

export const adviceFormats = ['bold', 'italic', 'underline', 'list', 'link'];
